import React, { useCallback, useState } from 'react';
import ModalUserAvatar from '../icons/UserAvatar/ModalUserAvatar';
import styles from './ConnectionBetweenUsersHeader.module.scss';
import ConnectionSide from './ConnectionSide/ConnectionSide';

function ConnectionBetweenUsersHeader(props) {
    const {
            eventId,
            className = '',
            baseRoute = '.',
            stretched = false,
            arrow = false,
            left,
            right,
            onArrowClick,
            children,
        } = props,
        [showModal, setShowModal] = useState(false);

    const handleCloseModal = useCallback(() => setShowModal(false), []);

    if (!left && !right) return null;

    return (
        <div
            className={[styles.ConnectionBetweenUsersHeader, className].join(
                ' '
            )}>
            <svg
                className={[stretched ? styles.stretched : ''].join(' ')}
                height='192.26656'
                viewBox='0 0 600 192.26655'>
                <g id='g1576' transform='translate(75)'>
                    <g id='middle' className={styles.middle}>
                        <path
                            d='M 149.84235,16.377941 c 73.00403,46.055905 77.99299,46.21992 150.37722,0 V 175.85109 c -79.58187,-49.57172 -73.39888,-46.7893 -150.37722,0 z'
                            id='path1012'
                        />
                    </g>
                    <g id='left' className={styles.left}>
                        <path d='m 149.86684,175.85107 c -15.65371,9.11352 -32.87743,16.41549 -53.74285,16.41549 -49.76672,0 -90.69861,-37.83831 -95.62233,-86.30442 C 0.16722,102.7385 0,99.449823 0,96.142571 0,75.769525 6.9025,58.945271 15.65371,43.653874 32.8124,17.400235 62.41974,0 96.12399,0 c 28.22313,0 49.70169,13.21043 69.6381,26.309379 13.16398,20.047895 26.50447,41.600776 26.50447,69.833192 0,33.174719 -16.82425,62.447619 -42.39972,79.708499' />
                        {left ? (
                            <ConnectionSide
                                eventId={eventId}
                                {...left}
                                baseRoute={baseRoute}
                                onShowAvatarModal={setShowModal}
                            />
                        ) : null}
                    </g>
                    <g transform='translate(258)'>
                        <g id='right' className={styles.right}>
                            {arrow ? (
                                <g
                                    className={styles.arrow}
                                    onClick={onArrowClick}>
                                    <rect
                                        width='149.68887'
                                        height='56.635132'
                                        x='84.520233'
                                        y='135.20178'
                                        ry='5.1263747'
                                    />
                                    <path d='m 207.94049,167.72478 v 4.55881 c 0,0.57774 0.52103,1.05171 1.16962,1.05171 0.2924,0 0.58325,-0.0996 0.80566,-0.28887 2.76073,-2.36284 7.69117,-6.5795 9.94798,-8.51043 0.31107,-0.26503 0.48527,-0.63383 0.48527,-1.01666 0,-0.38422 -0.1742,-0.75162 -0.48527,-1.01665 -2.25681,-1.93094 -7.18725,-6.14899 -9.94798,-8.50903 -0.22241,-0.19071 -0.51326,-0.29027 -0.80566,-0.29027 -0.64859,0 -1.16962,0.47257 -1.16962,1.05171 v 4.55881 h -47.6849 c -0.82589,0 -1.27725,0.79107 -1.55845,1.40228 -0.79418,1.72616 0,5.60631 0,5.60631 0,0.74321 0.73256,1.40228 1.55845,1.40228 z' />
                                </g>
                            ) : null}
                            <path d='m 174.9161,42.5112 c 9.09494,15.625838 16.34117,32.812403 16.34117,53.622081 0,3.316542 -0.15793,6.605219 -0.49237,9.828859 -4.92372,48.46611 -45.8649,86.30442 -95.64091,86.30442 -20.37305,0 -37.21588,-6.92107 -52.50728,-15.663 C 16.37236,159.417 -1,129.82824 -1,96.133281 -1,67.919445 12.20114,46.431594 25.30938,26.51376 45.34798,13.34049 66.91015,0 95.12399,0 c 33.23974,0 62.53122,16.879993 79.79211,42.5112' />
                            {right ? (
                                <ConnectionSide
                                    eventId={eventId}
                                    {...right}
                                    baseRoute={baseRoute}
                                    onShowAvatarModal={setShowModal}
                                />
                            ) : null}
                        </g>
                    </g>
                </g>
            </svg>
            {children}
            {showModal ? (
                <ModalUserAvatar user={showModal} onClose={handleCloseModal} />
            ) : null}
        </div>
    );
}

export default ConnectionBetweenUsersHeader;
